class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search-target');
        this.suggestionsList = this.querySelector('#predictive-search-suggestions');

        // Show suggestions initially if input is empty
        if (this.input && !this.input.value.trim().length) {
            this.showSuggestions();
        }

        this.input.addEventListener(
            'input',
            this.debounce(event => {
                this.onChange(event);
            }, 300).bind(this)
        );
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            this.showSuggestions();
            return;
        }

        this.hideSuggestions();
        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        console.log('🔍 Starting search for:', searchTerm);
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search-results`)
            .then(response => {
                console.log('📡 Response status:', response.status, response.statusText);
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then(text => {
                console.log('📄 Raw response text length:', text.length);
                console.log('📄 Raw response text:', text);

                const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
                const resultsSection = parsedDoc.querySelector('#shopify-section-predictive-search-results');

                console.log('🎯 Found results section:', resultsSection);

                if (!resultsSection) {
                    console.warn('⚠️ No results section found in response');
                    console.log(
                        '📋 Available elements:',
                        Array.from(parsedDoc.querySelectorAll('[id*="predictive"]')).map(el => el.id)
                    );
                    return;
                }

                const resultsMarkup = resultsSection.innerHTML;
                console.log('✨ Results markup:', resultsMarkup);
                console.log('📊 Results markup length:', resultsMarkup.length);

                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch(error => {
                console.error('❌ Error in getSearchResults:', error);
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.input.setAttribute('aria-expanded', 'false');
    }

    showSuggestions() {
        if (this.suggestionsList) {
            this.suggestionsList.style.display = 'block';
        }
    }

    hideSuggestions() {
        if (this.suggestionsList) {
            this.suggestionsList.style.display = 'none';
        }
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}
customElements.define('predictive-search', PredictiveSearch);
